export function getDoneBy(uuid, employeeNames, contacts) {
  let doneBy = '';
  let person = employeeNames.find((n) => {
    return n.uuid === uuid;
  });
  if (person) {
    doneBy = person.name;
  } else {
    person = contacts.find((c) => {
      return c.uuid === uuid;
    });
    if (person) {
      doneBy = person.name;
    }
  }
  if (doneBy) {
    doneBy = ' av ' + doneBy;
  }
  return doneBy;
}
